import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField } from "helpers/row-logic-helper";

import { shouldShowField } from "../loanDetailEditUtil";

import {
  shouldShowMaxAdvance,
  shouldShowAdditionalAdvanceAllocations,
  shouldShowNoticeForAdvance,
  shouldShowDrawFrequency,
  shouldShowDrawThresholdInterval,
  shouldShowDrawConditions,
  shouldShowRequiredEquity,
  shouldShowCompletion,
  shouldShowCovenants,
  shouldShowRestorationRetainage,
  shouldShowDevelopmentFee,
  shouldShowBudgetCostOverruns,
  shouldShowChangeOrders,
  shouldShowMisc
} from "./section-loan-additional-advances-rows-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  maxAdvance: {
    isVisible: data => shouldShowMaxAdvance(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "maximum Advance",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: " ",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.maxAdvance"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  additionalAdvanceAllocations: {
    isVisible: data => shouldShowAdditionalAdvanceAllocations(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Additional Advance Allocations",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.additionalAdvanceAllocations"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.additionalAdvanceAllocations"
      }
    ]
  },

  noticeForAdvance: {
    isVisible: data => shouldShowNoticeForAdvance(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Notice for Advance",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.noticeForAdvance"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.noticeForAdvance"
      }
    ]
  },

  drawFrequency: {
    isVisible: data => shouldShowDrawFrequency(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Frequency of Draws",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.drawFrequency"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.drawFrequency"
      }
    ]
  },

  drawThresholdInterval: {
    isVisible: data => shouldShowDrawThresholdInterval(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Draw Threshold/Intervals",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.drawThresholdInterval"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.drawThresholdInterval"
      }
    ]
  },

  drawConditions: {
    isVisible: data => shouldShowDrawConditions(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Conditions for Draws",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.drawConditions"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.drawConditions"
      }
    ]
  },

  requiredEquity: {
    isVisible: data => shouldShowRequiredEquity(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Required Equity",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.requiredEquity"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.requiredEquity"
      }
    ]
  },

  completion: {
    isVisible: data => shouldShowCompletion(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Completion",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.completion"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.completion"
      }
    ]
  },

  covenants: {
    isVisible: data => shouldShowCovenants(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Covenants",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.covenants"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.covenants"
      }
    ]
  },

  restorationRetainage: {
    isVisible: data => shouldShowRestorationRetainage(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Restoration/Retainage",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.restorationRetainage"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.restorationRetainage"
      }
    ]
  },

  developmentFee: {
    isVisible: data => shouldShowDevelopmentFee(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Development Fee",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.developmentFee"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.developmentFee"
      }
    ]
  },

  budgetCostOverruns: {
    isVisible: data => shouldShowBudgetCostOverruns(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Budget/Cost Overruns",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.budgetCostOverruns"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.budgetCostOverruns"
      }
    ]
  },

  changeOrders: {
    isVisible: data => shouldShowChangeOrders(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Change Orders",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.changeOrders"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.changeOrders"
      }
    ]
  },

  misc: {
    isVisible: data => shouldShowMisc(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Misc",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "additionalAdvances.misc"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.additionalAdvances.misc"
      }
    ]
  }
};
